import { render, staticRenderFns } from "./AgioRule.vue?vue&type=template&id=efded856&scoped=true"
import script from "./AgioRule.vue?vue&type=script&lang=js"
export * from "./AgioRule.vue?vue&type=script&lang=js"
import style0 from "./AgioRule.vue?vue&type=style&index=0&id=efded856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efded856",
  null
  
)

export default component.exports